<template>
    <div
      class="lms-wrapper-two"
    >
  
    <student-nav ></student-nav>
    <div class="lms-content">
      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
      <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
        <vue-custom-scrollbar
                  :style="`height: ${scrollHeight.content}px; position: relative; `"
                >
                <div class="px-2 py-4">
          <table class="table table-striped table-bordered ">
            <thead class="thead-secondary">
              <tr>
                <th>Сургалтын зар</th>
                <th>Багш</th>
                <th>Сургалтын нэр</th>
                <th>Эхлэх хугацаа</th>
                <th>Нэмэлт мэдээлэл</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(t,i) in tasks" :key="i">
                <td>{{ t.task }}</td>
                <td>{{ t.taskEn }}</td>
                <td>{{ t.st1 }}</td>
                <td>{{ t.d1 | moment('YYYY.MM.DD /dddd/') }}</td>
                <td><div v-html="t.taskDesc"></div></td>
              </tr>
            </tbody>
          </table>
        </div>
              </vue-custom-scrollbar>
        
      </div>
    </div>
      
    </div>
  </template>
  
  <script>
  import AsyncLoadError from "@/components/base/asyncLoadingError";
  import AsyncLoading from "@/components/base/asyncLoading";
  import vueCustomScrollbar from "vue-custom-scrollbar";
  import { request } from "@/api/all";
  import { localSave, localRead } from "@/libs/util";
  
  export default {
    components: {
      vueCustomScrollbar,
      studentHeader: () => ({
        component: import("@/views/modules/lms/student/components/header.vue"),
        loading: AsyncLoading,
        error: AsyncLoadError,
        delay: 100,
        timeout: 5000,
      }),
      studentNav: () => ({
        component: import("@/views/modules/lms/student/components/nav.vue"),
        loading: AsyncLoading,
        error: AsyncLoadError,
        delay: 100,
        timeout: 5000
      }),
    },
    data() {
      return {
        tasks: [],
        scrollHeight: {
          contentToolbarHeight: 49,
          nav: 0,
          content: 0,
          right: 0
        },
      };
    },
    mounted() {
      this.toggleBodyClass("addClass", "app-lms");
      require("@/assets/css/dynamic.lms.css");
  
      window.addEventListener("resize", this.getWindowHeight);
      this.getWindowHeight();
      this.init();
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWindowHeight);
      //this.toggleBodyClass("removeClass", "app-lms");
    },
    destroyed() {
      window.removeEventListener("resize", this.getWindowHeight);
      //this.toggleBodyClass("removeClass", "app-lms");
    },
    methods: {
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;
        if (addRemoveClass === "addClass") {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
      getWindowHeight() {
        let contentSub = 0;
        let navSub = 120;
        let rightSub = 210;
        if (screen.width <= 1024) {
          contentSub = 0;
          navSub = 85;
          rightSub = 85;
        }
  
        contentSub += this.scrollHeight.contentToolbarHeight;
        rightSub += this.scrollHeight.contentToolbarHeight;
  
        this.scrollHeight.content = window.innerHeight - contentSub;
        this.scrollHeight.nav = window.innerHeight - navSub;
        this.scrollHeight.right = window.innerHeight - rightSub;
      },
      init() {
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 200,
            ot: 609,
            model: {
              isPublic: true,
            }
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.tasks = res.data.tasks;
          }
        });
      },
    },
  };
  </script>
  